export default {"src":"/_next/static/media/reddit-logo-hover.094597e4.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};